// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3o9r4","productName":"Table_productName__3au2x"};